import iOverlays from './overlays';

const iErrorHandler = {

    init() {
        this.overlay = $('.I-js-overlay-wrapper').find('.I_OBJ_overlay__container');
    },

    handleError(thrownError) {
        this.overlay.load(window.iErrorHandlerOverlayUrl, {errorText: thrownError}, () => {
            iOverlays.openOverlay($('#overlay-error'));
            iOverlays.updateEvents();
        });
    },
};

export default iErrorHandler;
